<template>
  <div>
    <md-card-actions md-alignment="space-between">
      <div class="">
        <p class="card-category hidden md:block">
          {{ $t("common.show") }} {{ pagination.from }} {{ $t("common.to") }}
          {{ pagination.to }} {{ $t("common.of") }} {{ pagination.total }}
          {{ $t("common.entries") }}
        </p>
      </div>
      <pagination
        class="pagination-no-border pagination-success"
        v-model="pagination.currentPage"
        :per-page="perPage"
        :total="pagination.total"
        :noArrows="pagination.total < 10"
        firstAndLastMode
        @input="changePage"
      >
      </pagination>
    </md-card-actions>
  </div>
</template>

<script>
import { Pagination } from "@/components";

export default {
  name: "YvPagination",
  data() {
    return {
      initPage: true
    };
  },
  props: ["pagination"],
  components: { Pagination },
  computed: {
    perPage() {
      return +this.pagination.perPage;
    }
  },
  methods: {
    changePage() {
      // if (this.initPage) {
      //   this.initPage = false;
      //   return;
      // }
      this.$emit("changePage", this.pagination.currentPage);
    }
  },
  mounted() {}
};
</script>
